import MagmaLeftPseudoBox from './MagmaLeftPseudoBox';
import MagmaRightPseudoBox from './MagmaRightPseudoBox';

export const LeftPseudo = MagmaLeftPseudoBox;
export const RightPseudo = MagmaRightPseudoBox;
